import { Box, Collapse, Popover, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  getPatientExternalReferrals,
  setPatientExternalReferralsTrackingStatus,
} from "../../api/group";
import DownArrow from "../../assets/SVG/downArrow";
import FormInfoErja from "./formInfoErja";

export default function ErjaParvandeh({ areaId, patientId }) {
  const [selectedTab, setSelectedTab] = useState({ moduleName: "ارجاعات" });
  const [collapseAz, setCollapseAz] = useState();
  const [collapseKhedmat, setCollapseKhedmat] = useState();
  const [collapseMali, setCollapseMali] = useState();
  const [referralStatus, setReferralStatus] = useState();
  const [dataInfo, setDataInfo] = useState();
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null);
    // setOpenPopover(false);
    // setDate();
  };

  useEffect(() => {
    // if (collapseAz) {
    getPatientExternalReferrals(areaId, patientId)
      .then((x) => {
        setDataInfo(x);
        // if (x.status === "جراحی و بستری") {
        //   setReferralStatus({ text: "جراحی و بستری", value: "SURGERY" });
        // }
        // if (x.status === "عدم پیگیری بیمار") {
        //   setReferralStatus({
        //     text: "عدم پیگیری بیمار",
        //     value: "USER_NOT_TRACK",
        //   });
        // }
        // if (x.status === "خدمات سرپایی") {
        //   setReferralStatus({ text: "خدمات سرپایی", value: "RAPID_SERV" });
        // }
      })
      .catch(() => {});
    // }
  }, []);

  return (
    <>
      <Popover
        sx={{
          "& .MuiPaper-root": {
            width: "10vw",
            height: "115px",
            padding: "15px 5px",
            borderRadius: "13px",
            bgcolor: "white",
            cursor: "pointer",
          },
          // "& .MuiBackdrop-root": {
          //   backgroundColor: "#00000060",
          // },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box textAlign={"center"}>
          {[
            {
              text: "نقص مدارک",
              value: "NOT_COMP_DOC",
            },
            { text: "عدم پیگیری بیمار", value: "USER_NOT_TRACK" },
            { text: "جراحی و بستری", value: "SURGERY" },
            { text: "خدمات سرپایی", value: "RAPID_SERV" },
          ]?.map((x, i) => (
            <Typography
              onClick={(e) => {
                setAnchorEl(null);
                setReferralStatus(x);
              }}
              fontSize={"14px"}
              mt={i !== 0 ? "10px" : "0px"}
            >
              {x.text}
            </Typography>
          ))}
        </Box>
      </Popover>
      <Box
        height={"80vh"}
        sx={{
          overflow: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Box display="flex" gap="20px">
          {[
            { moduleName: "ارجاعات" },
            // { moduleName: "خدمت/پرونده مالی" },
            // { moduleName: "تماس" },
          ]?.map((x, i) => (
            <Typography
              onClick={() => {
                setSelectedTab(x);
              }}
              sx={{ cursor: "pointer" }}
              mt="20px"
              fontWeight="bold"
              color={
                selectedTab?.moduleName === x.moduleName
                  ? "var(--emr-darkblue)"
                  : "var(--emr-disable)"
              }
            >
              {x.moduleName}
            </Typography>
          ))}
        </Box>
        {/* {selectedTab?.moduleName === "ارجاعات" && ( */}
        <>
          {dataInfo?.map((x, i) => (
            <>
              <Box
                onClick={() =>
                  collapseAz === i ? setCollapseAz(null) : setCollapseAz(i)
                }
                bgcolor="#EFF1F7"
                borderRadius={"7px"}
                p="10px"
                display="flex"
                justifyContent={"space-between"}
                alignItems="center"
                mt="20px"
                sx={{ cursor: "pointer" }}
              >
                <Typography color="var(--emr-darkblue)">
                  {"اطلاعات ارجاع دکتر" + " " + x.doctor}
                </Typography>
                <DownArrow transform={collapseAz === i} />
              </Box>
              <Collapse in={collapseAz === i} timeout="auto">
                <Box
                  mt="-5px"
                  display="flex"
                  justifyContent={"space-between"}
                  bgcolor="#EFF1F7"
                  p="20px"
                >
                  <Box display="flex">
                    <Typography sx={{ width: "10vw", color: "#636971" }}>
                      {"ارجاع از"}
                    </Typography>
                    <Typography sx={{ width: "10vw", color: "#636971" }}>
                      {"ارجاع به"}
                    </Typography>
                    <Typography sx={{ width: "10vw", color: "#636971" }}>
                      {"علت ارجاع"}
                    </Typography>
                  </Box>
                  <Typography
                    textAlign={"center"}
                    sx={{ width: "10vw", color: "#636971" }}
                  >
                    {"عملیات"}
                  </Typography>
                </Box>
                <Box
                  mt="-5px"
                  display="flex"
                  justifyContent={"space-between"}
                  bgcolor="#EFF1F7"
                  p="20px"
                >
                  <Box display="flex">
                    <Typography sx={{ width: "10vw" }}>
                      {x.referredFrom}
                    </Typography>
                    <Typography sx={{ width: "10vw" }}>
                      {x.referredTo}
                    </Typography>
                    <Typography sx={{ width: "19vw" }}>{x.reason}</Typography>
                  </Box>
                  <Box
                    bgcolor="#606060"
                    p="6px 5px"
                    sx={{ width: "10vw", cursor: "pointer" }}
                    display="flex"
                    justifyContent={"space-between"}
                    borderRadius="9px"
                    height="23px"
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                    }}
                  >
                    <Typography
                      sx={{ minWidth: "max-width" }}
                      fontSize={"13px"}
                      color="white"
                    >
                      {referralStatus?.text || x.status}
                    </Typography>
                    <DownArrow color="white" />
                  </Box>
                </Box>
                <Box
                  bgcolor="#EFF1F7"
                  display="flex"
                  justifyContent={"end"}
                  p="10px 30px"
                >
                  <Box
                    width={"fit-content"}
                    p="7px 30px"
                    borderRadius={"9px"}
                    color="white"
                    bgcolor="var(--emr-darkblue)"
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      setPatientExternalReferralsTrackingStatus({
                        areaId: areaId,
                        formId: x.formId,
                        patientId: patientId,
                        status: referralStatus?.value,
                      })
                        .then(() => {
                          toast.success("ثبت شد");
                        })
                        .catch(() => {})
                    }
                  >
                    {"ثبت"}
                  </Box>
                </Box>
                <FormInfoErja
                  areaId={areaId}
                  patientId={patientId}
                  dataInfo={x}
                />
              </Collapse>
            </>
          ))}
        </>
        {/* )} */}
        {selectedTab?.moduleName === "خدمت/پرونده مالی" && (
          <>
            <Box
              onClick={() => setCollapseKhedmat(!collapseKhedmat)}
              bgcolor="#EFF1F7"
              borderRadius={"7px"}
              p="10px"
              display="flex"
              justifyContent={"space-between"}
              alignItems="center"
              mt="20px"
              sx={{ cursor: "pointer" }}
            >
              <Typography color="var(--emr-darkblue)">
                {"اطلاعات مربوط به خدمت"}
              </Typography>
              <DownArrow transform={collapseKhedmat} />
            </Box>
            <Collapse in={collapseKhedmat} timeout="auto">
              <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
                mmd
              </Box>
            </Collapse>
            <Box
              onClick={() => setCollapseMali(!collapseMali)}
              bgcolor="#EFF1F7"
              borderRadius={"7px"}
              p="10px"
              display="flex"
              justifyContent={"space-between"}
              alignItems="center"
              mt="20px"
              sx={{ cursor: "pointer" }}
            >
              <Typography color="var(--emr-darkblue)">
                {"اطلاعات مربوط به خدمت"}
              </Typography>
              <DownArrow transform={collapseMali} />
            </Box>
            <Collapse in={collapseMali} timeout="auto">
              <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
                mmd
              </Box>
            </Collapse>
          </>
        )}
        {selectedTab?.moduleName === "تماس" && (
          <>
            <Box
              onClick={() => setCollapseMali(!collapseMali)}
              bgcolor="#EFF1F7"
              borderRadius={"7px"}
              p="10px"
              display="flex"
              justifyContent={"space-between"}
              alignItems="center"
              mt="20px"
              sx={{ cursor: "pointer" }}
            >
              <Typography color="var(--emr-darkblue)">{"تماس"}</Typography>
              <DownArrow transform={collapseMali} />
            </Box>
            <Collapse in={collapseMali} timeout="auto">
              <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
                mmd
              </Box>
            </Collapse>
          </>
        )}
      </Box>
    </>
  );
}
